import { func, node } from 'prop-types';
import React, { createContext, PureComponent } from 'react';

import { ENV } from '../reactor/common';

const { IS_WEB, IS_SERVER } = ENV;
const Context = createContext();
const { Provider, Consumer: ConsumerEvents } = Context;

class ProviderEvents extends PureComponent {
  static propTypes = {
    children: node,
    onBack: func,
    onUri: func,
  };

  static defaultProps = {
    children: undefined,

    onBack: undefined,

    onUri(to, target = '_blank') {
      if (IS_WEB && !IS_SERVER) window.open(to, target);
    },
  };

  state = {
    stories: false,
    info: undefined,
  }

  onInfo = (info) => {
    this.setState({ info });
  }

  onStories = () => {
    const { state: { stories } } = this;
    this.setState({ stories: !stories });
  }

  render() {
    const {
      onInfo, onStories,
      props: { children, onBack, onUri },
      state,
    } = this;

    return (
      <Provider
        value={{
          ...state, onBack, onUri, onInfo, onStories,
        }}
      >
        { children }
      </Provider>
    );
  }
}

export { ConsumerEvents, ProviderEvents };
